<template>
	<page class="dashboard" title="Brugere" style="background-color: #F0F0F0;">
		<toolbar-search-view placeholder="Brugertype" :options="_aqt_role_options" slot="tools" v-model="filter.role" />
		<organisations-search-view slot="tools" v-model="filter.org" />
		<toolbar-search-view placeholder="Rolle" :options="_org_role_options" slot="tools" v-model="filter.org_role" />
		<input class="tool-text" placeholder="Søg" type="text" slot="tools" v-model="search" />
		<button-view style="float: left;" slot="tools" @click="createUser">+ Ny</button-view>
		<new-table-view class="list" @itemClick="itemClick" :columns="[
			{
				label: 'Navn',
				name: 'name'
			},
			{
				label: 'Brugernavn',
				name: 'username'
			},
			{
				label: 'E-mail',
				name: 'email'
			},
			{
				label: 'Brugertype',
				name: 'role_str'
			},
			{
				label: 'Medlemskaber',
				name: 'memberships_str'
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: '...'
				},
				weight: '100px'
			},
		]" :items="_items" @context="itemContext" @delete="itemContext" />
	</page>
</template>

<script>
	import ContextPopupView from '../views/ContextPopupView';
	import { bus } from '../../bus'

	import user from '../model/user';

	const AQT_ROLES = {
		AQT_ADMIN: {
			label: 'Aquatime',
			class: 'aqt_admin',
		},
		AQT_CUSTOMER: {
			label: 'Kunde',
			class: 'aqt_customer',
		},
		AQT_PARTNER: {
			label: 'Partner',
			class: 'aqt_partner',
		},
	};

	const ORG_ROLES = {
		ORG_ADMIN: {
			label: 'Administrator',
			class: 'org_admin',
		},
		ORG_CAREGIVER: {
			label: 'Plejer',
			class: 'org_caregiver',
		},
	};

	function membershipsToString(memberships) {
		return memberships.map(val => `<span class="tag ${ORG_ROLES[val.role].class}">${val._organisation.label}</span>`).join(' ');
	}

    export default {
		data() {
			return {
				items: [],
				search: '',
				filter: {
					role: null,
					org: null,
					org_role: null,
				},
			};
		},
		components: {

		},
		watch: {

		},
		computed: {
			_items() {
				return this.items.filter(item => {
					if (this.filter.role && item.role != this.filter.role) return false;
					if (this.filter.org && !item._memberships.find(val => val._organisation.id == this.filter.org)) return false;
					if (this.filter.org_role && !item._memberships.find(val => val.role == this.filter.org_role)) return false;
					if (this.search && !item.name.toLowerCase().includes(this.search.toLowerCase())) return false;

					return true;
				
				});
			},
			_aqt_role_options() {
				return Object.keys(AQT_ROLES).map(key => ({
					key,
					value: AQT_ROLES[key].label,
				})).sort((a, b) => a.value.localeCompare(b.value));
			},
			_org_role_options() {
				return Object.keys(ORG_ROLES).map(key => ({
					key,
					value: ORG_ROLES[key].label,
				})).sort((a, b) => a.value.localeCompare(b.value));
			},
		},
		methods: {
			async normalizeUser(user) {
				const memberships = (await this.axios.get(`/users/${user.id}/organisation-memberships`)).data.content;

				return {
					...user,
					_memberships: memberships,
					memberships_str: membershipsToString(memberships),
					role_str: `<span class="tag ${AQT_ROLES[user.role].class}">${AQT_ROLES[user.role].label}</span>`,
				};
			},
			async itemDelete(item, event) {
				event.stopPropagation();
				console.log('item delete', item);

				if (confirm('Sikker?')) {
					await this.axios.delete(`/users/${item.id}`);
					this.update();
				}
			},
			itemContext(item, event) {
				event.stopPropagation();

				const actions = [];

				for (const membership of item._memberships) {
					actions.push({
						label: `Fjern fra ${membership._organisation.label}`,
						action: async () => {
							if (!confirm(`Fjern ${item.name} fra ${membership._organisation.label}?`)) return;

							await this.axios.delete(`/organisations/${membership.organisationId}/memberships/${membership.userId}`);
							this.update();
						},
					});
				}

				actions.push({
					label: '+ Organisation',
					action: () => user.membership(item.id, () => this.update()),
				});

				actions.push(null);

				actions.push({
					label: 'Skift adgangskode',
					action: () => this.itemUpdatePassword(item),
				});

				actions.push(null);

				actions.push({
					label: 'Rediger',
					action: () => this.itemClick(item),
				});

				actions.push({
					label: 'Slet',
					action: () => this.itemDelete(item, event),
				});

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					left: 20,
					actions,
				});
			},
			async itemUpdatePassword(item) {
				const password = prompt('Ny adgangskode');

				if (password) {
					await this.axios.put(`/users/${item.id}/password`, password, {
						headers: {
							'Content-Type': 'text/plain'
						},
					});
				}
			},
			async itemClick(item) {
				console.log('item click', item);
				const self = this;

				user.open(item.id, () => {
					self.update();
				});
			},
			async updateItems() {
				const items = (await this.axios.get('/users?_size=1000')).data.content;
				const promises = [];

				for (var i = 0; i < items.length; ++i) {
					promises.push(this.normalizeUser(items[i]));
				}

				this.items = await Promise.all(promises);
			},
			async update() {
				this.updateItems();
				return true;
			},
			createUser() {
				console.log('Create user');

				const self = this;

				user.open(null, (user) => {
					console.log({ user });

					self.update();
				});
			}
		},
		mounted() {
			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.tool-text {
		display: block;
		float: left;
		margin-left: 10px;
		height: 36px;
		border-radius: 20px;
		padding-left: 20px;
		border: 1px solid #cecece;
	}

	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 290px 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		padding: 30px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 2 / 3;
		background-color: #f0f0f0;		
	}

	.list {
		width: 100%;
		height: 100%;
		border-left: 1px solid #cecece;
		background-color: white;
	}

	.list::v-deep {
		.tag {
			padding: 5px 10px;
			border-radius: 20px;
			color: white;
			font-size: 12px;
			white-space: nowrap;
		}

		.aqt_admin {
			background-color: #45a9f2;
		}

		.aqt_partner {
			background-color: #a36be2;
		}

		.aqt_customer {
			background-color: #61ce70;
		}

		.org_admin {
			background-color: rgb(206, 54, 54);
		}

		.org_caregiver {
			background-color: #e29842;
		}
	}
</style>